module.exports = __webpack_public_path__ + "static/media/OldManInDingyNoBG.83756dd6.png";